import { render, staticRenderFns } from "./companyInfo.vue?vue&type=template&id=25ec01c6&scoped=true"
import script from "./companyInfo.vue?vue&type=script&lang=js"
export * from "./companyInfo.vue?vue&type=script&lang=js"
import style0 from "./companyInfo.vue?vue&type=style&index=0&id=25ec01c6&prod&scoped=true&lang=css"
import style1 from "./companyInfo.vue?vue&type=style&index=1&id=25ec01c6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25ec01c6",
  null
  
)

export default component.exports